// Mock data for K.S.E. Inc. (KSE Fashion) corporate website
// NOTE: All data below is MOCKED for the frontend-only build.

export const company = {
  name: "K.S.E. Inc.",
  shortName: "KSE",
  established: "EST. 1998",
  tagline: "Relentless Pursuit of Quality.",
  heroSubtitle:
    "For over 30 years, K.S.E. Inc. has been a trusted production house in garment manufacturing \u2014 sourcing and producing world-class Men's, Women's and Kid's wear for leading brands across the globe.",
};

export const nav = [
  { label: "Products", href: "#collections" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Markets", href: "#clients" },
  { label: "Showroom", href: "/showroom", isRoute: true },
  { label: "Insights", href: "/blog", isRoute: true },
];

export const heroImage =
  "https://images.unsplash.com/photo-1589793463357-5fb813435467";

export const topStats = [
  { value: "30+", label: "Years of Experience", icon: "Award" },
  { value: "3", label: "Manufacturing Facilities", icon: "Factory" },
  { value: "4,80,000", label: "Pieces per Month", icon: "Package" },
  { value: "500+", label: "Skilled Employees", icon: "Users" },
];

export const about = {
  eyebrow: "WHO WE ARE",
  title: "A Production House Built on Trust.",
  paragraphs: [
    "\u201CK.S.E. Inc.\u201D is a production house in garment manufacturing built to meet the specific needs, trust and satisfaction of every customer. For the last 30 years we have been producing and sourcing all types of Men's, Women's and Kid's wear \u2014 including apparel products, T-shirts, sleepwear, outerwear and dresses in both knit and woven fabrics.",
    "Centrally located in Mumbai with manufacturing facilities in Mumbai, Umargam (Gujarat) and Tiruppur, our group executes work across sourcing, order execution, production management, merchandising, product design & development, compliance assessment, brand safety and quality \u2014 all under one roof.",
  ],
  image:
    "https://images.pexels.com/photos/31031031/pexels-photo-31031031.jpeg",
};

export const facilities = [
  {
    name: "Mumbai Factory",
    location: "Andheri (East), Mumbai",
    desc: "Headquarters and core production hub with full-fledged merchandising, design and logistics teams.",
    image: "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4",
  },
  {
    name: "Umargam Factory",
    location: "Umargam, Gujarat",
    desc: "Dedicated knit & woven production unit supporting large volume export orders.",
    image: "https://images.pexels.com/photos/31199564/pexels-photo-31199564.jpeg",
  },
  {
    name: "Tiruppur Factory",
    location: "Tiruppur, Tamil Nadu",
    desc: "Specialised knits facility in India's largest knitwear cluster.",
    image: "https://images.unsplash.com/photo-1589793463357-5fb813435467",
  },
];

export const sustainability = {
  eyebrow: "OUR STRENGTH",
  title: "Under One Roof,\nEnd to End.",
  desc: "From merchandising and designing to a dedicated production, logistics and documentation team \u2014 every stage of the garment journey is planned and executed in-house, within schedule and to the highest quality standards.",
  image:
    "https://images.unsplash.com/photo-1640746942093-cec8e647596d",
  metrics: [
    { value: "4,00,000", unit: "pcs/month", label: "Knits Production Capacity", icon: "Shirt" },
    { value: "80,000", unit: "pcs/month", label: "Shirts Production Capacity", icon: "Layers" },
    { value: "500", unit: "seats", label: "Split across 15 Units", icon: "Armchair" },
  ],
  subMetrics: [
    { value: "ISO 14001:2015", label: "Environment Management Certified", icon: "Leaf" },
    { value: "7-Seam", label: "Fully Taped Shirt Capability", icon: "Scissors" },
  ],
};

export const machinery = {
  knits: {
    title: "Knits Unit",
    note: "500 seats split into 15 units. Capacity: 4,00,000 pcs per month.",
    machines: [
      { name: "Flat Locks", count: "40" },
      { name: "Over Lock", count: "120" },
      { name: "Single Needle", count: "250" },
      { name: "Double Needle", count: "30" },
      { name: "Iron Press", count: "60" },
      { name: "Cutting Machine", count: "20" },
    ],
  },
  shirts: {
    title: "Shirts Unit",
    note: "Specialised units for Formal & Casual shirts. Capacity: 80,000 pcs per month.",
    machines: [
      { name: "Single Needle", count: "140" },
      { name: "Feed of the Arm", count: "06" },
      { name: "Placket Machine", count: "03" },
      { name: "Fusing Machine", count: "03" },
      { name: "Computerized Button", count: "04" },
      { name: "Button Hole Machine", count: "05" },
      { name: "Steam Pressing", count: "18" },
    ],
  },
};

export const exploreCards = [
  {
    title: "Our Capabilities",
    href: "#capabilities",
    image:
      "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4",
  },
  {
    title: "Our People",
    href: "#about",
    image:
      "https://images.pexels.com/photos/31031031/pexels-photo-31031031.jpeg",
  },
  {
    title: "Our Showroom",
    href: "/showroom",
    isRoute: true,
    image:
      "https://images.pexels.com/photos/8311878/pexels-photo-8311878.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const productCategories = [
  {
    title: "Cotton & Cotton Lycra T-Shirts",
    image:
      "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "100% Cotton Single Jersey",
      "95% Cotton 5% Lycra Pique",
      "100% Cotton Indigo Jacquard",
      "100% Cotton AOP",
    ],
  },
  {
    title: "CVC & Polyester Cotton T-Shirts",
    image:
      "https://images.unsplash.com/photo-1693443687750-611ad77f3aba?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "52/48 Pique 26 Gauge",
      "Engineering Jacquard Stripes",
      "65/35 Digital AOP",
      "Two Tone Pique Cut & Sew",
    ],
  },
  {
    title: "100% Polyester T-Shirts",
    image:
      "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "Polyester Softy Digital AOP",
      "Polyester Pique",
      "Feeder Striper",
      "Grindle Finish",
    ],
  },
  {
    title: "Stand Pack Shirts",
    image:
      "https://images.unsplash.com/photo-1620799139834-6b8f844fbe61?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "100% Cotton Oxford Checks",
      "Big Checks & Stripes",
      "75/25 PC Checks",
      "Oxford Weft Stripes",
    ],
  },
  {
    title: "Casual Shirts",
    image:
      "https://images.unsplash.com/photo-1548768041-2fceab4c0b85?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "100% Cotton Corduroy",
      "Denim with Layering Effect",
      "Viscose Tie & Dye",
      "Recycled Flannel",
    ],
  },
  {
    title: "Ladies Pajamas, Shorts & Hats",
    image:
      "https://images.unsplash.com/photo-1604176354204-9268737828e4?crop=entropy&cs=srgb&fm=jpg&q=85",
    items: [
      "100% Cotton Women's Pajama Set",
      "AOP Front Open Girls Set",
      "Viscose Printed Shorts",
      "Cotton Poplin Bucket Hats",
    ],
  },
];

export const clients = {
  eyebrow: "MARKETS & INDUSTRIES",
  title: "Brands we manufacture for, by market",
  subtitle: "Six regions, four continents. Pick your market to see who we already supply there.",
  countries: [
    {
      region: "United Kingdom",
      code: "gb",
      coords: [-1.5, 52.5],
      brands: [
        { name: "ASOS", domain: "asos.com" },
        { name: "Soul Star", domain: "soulstarclothing.com" },
      ],
    },
    {
      region: "Turkey",
      code: "tr",
      coords: [35, 39],
      brands: [
        { name: "LC Waikiki", domain: "lcwaikiki.com" },
        { name: "LTB Jeans", domain: "ltb.com" },
      ],
    },
    {
      region: "Middle East",
      code: "ae",
      coords: [54, 24],
      brands: [
        { name: "Morelli" },
        { name: "Milane" },
        { name: "Steel & Jelly", domain: "steelandjelly.com" },
      ],
    },
    {
      region: "Latin America",
      code: "br",
      coords: [-51, -14],
      brands: [{ name: "M.Gee" }, { name: "It's The Fashion" }, { name: "R&B" }],
    },
    {
      region: "United States",
      code: "us",
      coords: [-98, 39],
      brands: [{ name: "Tom Baine" }, { name: "Performance Collection" }],
    },
    {
      region: "South Africa",
      code: "za",
      coords: [24, -29],
      brands: [
        { name: "Superbalist", domain: "superbalist.com" },
        { name: "The Style Republic" },
      ],
    },
  ],
};

export const industries = [
  { name: "Online fast fashion", note: "High-volume knits, quick repeats", example: "ASOS, Superbalist" },
  { name: "High-street retail", note: "Seasonal ranges, EU sizing", example: "LC Waikiki, LTB" },
  { name: "Private label & buying houses", note: "Your label, our floor", example: "Middle East & LatAm labels" },
  { name: "Kids & family wear", note: "Knit & woven, tested trims", example: "Soul Star" },
  { name: "Sleepwear & loungewear", note: "Pyjama sets, AOP prints", example: "Ladies & girls ranges" },
  { name: "Performance & polyester", note: "Sublimation, sports tees", example: "Performance Collection" },
];

export const enquiryOptions = {
  quantities: ["500 – 2,000 pcs", "2,000 – 10,000 pcs", "10,000 – 50,000 pcs", "50,000+ pcs"],
  timelines: ["Sampling now", "Bulk in 1–3 months", "Planning next season"],
};

export const news = {
  title: "The Latest from KSE",
  items: [
    {
      date: "June 12, 2025",
      title: "KSE Expands Tiruppur Knits Capacity to 4 Lakh Pieces",
      image: "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4",
    },
    {
      date: "April 03, 2025",
      title: "New Recycled Flannel & Sustainable Fabric Line Launched",
      image: "https://images.unsplash.com/photo-1640746942093-cec8e647596d",
    },
    {
      date: "January 20, 2025",
      title: "KSE Achieves ISO 14001:2015 Environment Certification",
      image: "https://images.pexels.com/photos/31199564/pexels-photo-31199564.jpeg",
    },
  ],
};

export const certifications = {
  eyebrow: "QUALITY & COMPLIANCE",
  title: "Accreditations & Certifications",
  subtitle:
    "Independently audited and certified for quality, environment and ethical manufacturing.",
  items: [
    {
      standard: "ISO 14001:2015",
      title: "Environment Management System",
      issuer: "QRO Certification LLP",
      scope: "Manufacturing of Readymade Garments",
      number: "304920022915E",
      note: "Independently assessed and compliant. Subject to annual surveillance audits.",
    },
    {
      standard: "TUV Austria CERT",
      title: "Trading of Textile Products",
      issuer: "TUV Austria Cert GmbH, Vienna",
      scope: "Textile Products Trading & Manufacturing",
      number: "Audited per TUV Austria procedures",
      note: "Conducted in accordance with TUV Austria CERT auditing & certification procedures with regular surveillance audits.",
    },
  ],
};

export const social = {
  whatsapp: "919820010399",
  whatsappDisplay: "+91 98200 10399",
  linkedin: "https://www.linkedin.com/company/kse-inc",
  mapEmbed:
    "https://www.google.com/maps?q=Niraj%20Industrial%20Estate%20Off%20Mahakali%20Caves%20Road%20Andheri%20East%20Mumbai%20400093&output=embed",
};

// 360 showroom now shows KSE's actual garments grouped by zone.
export const showroom = {
  title: "360\u00B0 Virtual Showroom",
  subtitle:
    "Step inside the K.S.E. Inc. showroom. Drag left / right to walk past our display walls of men's t-shirts, shirts, casual wear and nightwear.",
  zones: [
    {
      id: "tshirts",
      label: "Men's T-Shirts",
      wall:
        "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      garments: [
        { name: "Cotton Single Jersey Tee", fabric: "100% Cotton", image: "https://images.unsplash.com/photo-1581655353564-df123a1eb820?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Cotton Lycra Pique Polo", fabric: "95% Cotton 5% Lycra", image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "CVC Cut & Sew Tee", fabric: "52/48 Poly Cotton", image: "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Digital AOP Softy Tee", fabric: "100% Polyester", image: "https://images.unsplash.com/photo-1693443687750-611ad77f3aba?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
      ],
    },
    {
      id: "shirts",
      label: "Formal Shirts",
      wall:
        "https://images.unsplash.com/photo-1561053720-76cd73ff22c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      garments: [
        { name: "Oxford Check Shirt", fabric: "100% Cotton Oxford", image: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Poplin Formal Shirt", fabric: "52/48 PC", image: "https://images.unsplash.com/photo-1620799139834-6b8f844fbe61?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Stand Pack Stripe Shirt", fabric: "100% Cotton", image: "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
      ],
    },
    {
      id: "casual",
      label: "Casual Shirts & Knitwear",
      wall:
        "https://images.unsplash.com/photo-1618354691551-44de113f0164?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      garments: [
        { name: "Corduroy Casual Shirt", fabric: "100% Cotton Corduroy", image: "https://images.unsplash.com/photo-1548768041-2fceab4c0b85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Recycled Flannel Shirt", fabric: "Cotton / CVC Recycled", image: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "French Terry Sweatshirt", fabric: "Cotton Knit", image: "https://images.unsplash.com/photo-1618354691551-44de113f0164?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
      ],
    },
    {
      id: "nightwear",
      label: "Nightwear & Loungewear",
      wall:
        "https://images.unsplash.com/photo-1604176354204-9268737828e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      garments: [
        { name: "Cotton Pajama Set", fabric: "100% Cotton", image: "https://images.unsplash.com/photo-1604176354204-9268737828e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "AOP Loungewear Set", fabric: "100% Cotton AOP", image: "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
        { name: "Viscose Printed Shorts", fabric: "Viscose", image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
      ],
    },
  ],
};

// Machinery & Assets showcase (large real photos of the units running).
export const machineryUnits = [
  {
    id: "knits",
    name: "Knits Unit",
    capacity: "4,00,000 pcs / month",
    seats: "500 seats \u00B7 15 units",
    gallery: [
      { image: "https://images.unsplash.com/photo-1606501126768-b78d4569d3f9", caption: "Single Needle Lines", count: "250" },
      { image: "https://images.pexels.com/photos/31199588/pexels-photo-31199588.jpeg", caption: "Over Lock Machines", count: "120" },
      { image: "https://images.pexels.com/photos/4492077/pexels-photo-4492077.jpeg", caption: "Flat Lock Machines", count: "40" },
      { image: "https://images.unsplash.com/photo-1596552571892-2dda2c594670", caption: "Cutting Department", count: "20" },
    ],
    specs: [
      { name: "Single Needle", count: "250" },
      { name: "Over Lock", count: "120" },
      { name: "Flat Locks", count: "40" },
      { name: "Double Needle", count: "30" },
      { name: "Iron Press", count: "60" },
      { name: "Cutting Machine", count: "20" },
    ],
  },
  {
    id: "shirts",
    name: "Shirts Unit",
    capacity: "80,000 pcs / month",
    seats: "Formal & Casual specialised lines",
    gallery: [
      { image: "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4", caption: "Single Needle Lines", count: "140" },
      { image: "https://images.unsplash.com/photo-1736281957869-7f80909c3b2e", caption: "Computerized Button & Bartack", count: "05" },
      { image: "https://images.pexels.com/photos/4621890/pexels-photo-4621890.jpeg", caption: "Fusing & Cutting", count: "03" },
      { image: "https://images.pexels.com/photos/31199564/pexels-photo-31199564.jpeg", caption: "Steam Pressing & Finishing", count: "18" },
    ],
    specs: [
      { name: "Single Needle", count: "140" },
      { name: "Steam Pressing", count: "18" },
      { name: "Feed of the Arm", count: "06" },
      { name: "Button Hole", count: "05" },
      { name: "Computerized Button", count: "04" },
      { name: "Fusing / Placket", count: "03" },
    ],
  },
];

// Rich product collection (TataCliq-style filterable gallery).
export const collection = {
  filters: ["All", "T-Shirts", "Shirts", "Casual", "Nightwear", "Kids"],
  products: [
    { name: "Cotton Single Jersey Tee", category: "T-Shirts", fabric: "100% Cotton", tags: ["Knit", "MOQ 500"], image: "https://images.unsplash.com/photo-1581655353564-df123a1eb820?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Cotton Lycra Pique Polo", category: "T-Shirts", fabric: "95% Cotton 5% Lycra", tags: ["Knit", "Pique"], image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "CVC Cut & Sew Tee", category: "T-Shirts", fabric: "52% Cotton 48% Poly", tags: ["Knit", "Cut & Sew"], image: "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Polyester Digital AOP Tee", category: "T-Shirts", fabric: "100% Polyester Softy", tags: ["Sublimation"], image: "https://images.unsplash.com/photo-1693443687750-611ad77f3aba?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Oxford Check Shirt", category: "Shirts", fabric: "100% Cotton Oxford", tags: ["Woven", "Formal"], image: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Poplin Formal Shirt", category: "Shirts", fabric: "52/48 PC", tags: ["Woven", "Rotary Print"], image: "https://images.unsplash.com/photo-1561053720-76cd73ff22c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Stand Pack Stripe Shirt", category: "Shirts", fabric: "100% Cotton", tags: ["Woven", "Yarn Dyed"], image: "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Corduroy Casual Shirt", category: "Casual", fabric: "100% Cotton Corduroy", tags: ["Woven", "Casual"], image: "https://images.unsplash.com/photo-1548768041-2fceab4c0b85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "French Terry Sweatshirt", category: "Casual", fabric: "Cotton Knit", tags: ["Knit", "Winter"], image: "https://images.unsplash.com/photo-1618354691551-44de113f0164?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Recycled Flannel Shirt", category: "Casual", fabric: "Cotton / CVC Recycled", tags: ["Sustainable"], image: "https://images.unsplash.com/photo-1620799139834-6b8f844fbe61?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Cotton Pajama Set", category: "Nightwear", fabric: "100% Cotton", tags: ["Knit", "Set"], image: "https://images.unsplash.com/photo-1604176354204-9268737828e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "AOP Loungewear Set", category: "Nightwear", fabric: "100% Cotton AOP", tags: ["Print", "Set"], image: "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
    { name: "Kids Cotton Hoodie", category: "Kids", fabric: "Cotton Fleece", tags: ["Knit", "Kids"], image: "https://images.pexels.com/photos/15395266/pexels-photo-15395266.jpeg?auto=compress&cs=tinysrgb&w=800" },
    { name: "Girls AOP Pajama Set", category: "Kids", fabric: "100% Cotton AOP", tags: ["Print", "Kids"], image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  ],
};

export const brochureOptions = {
  interests: ["T-Shirts", "Shirts", "Casual Wear", "Nightwear", "Kids Wear", "Other"],
};

export const formOptions = {
  businessTypes: [
    "Retailer",
    "Wholesaler",
    "Distributor",
    "Chain Store",
    "Online B2B",
    "B2C / D2C Brand",
    "Buying House / Agent",
    "Brand / Label",
    "Other",
  ],
  countries: [
    "United Kingdom", "Turkey", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Oman",
    "Brazil", "Chile", "Colombia", "Mexico", "United States", "Canada", "South Africa", "Kenya",
    "Nigeria", "India", "Bangladesh", "Sri Lanka", "France", "Germany", "Spain", "Italy",
    "Netherlands", "Belgium", "Sweden", "Denmark", "Poland", "Portugal", "Greece", "Ireland",
    "Australia", "New Zealand", "Japan", "South Korea", "Singapore", "Malaysia", "Indonesia",
    "Vietnam", "Thailand", "China", "Egypt", "Morocco", "Jordan", "Israel", "Russia", "Other",
  ],
  cities: [
    "London", "Manchester", "Istanbul", "Dubai", "Abu Dhabi", "Sharjah", "Riyadh", "Jeddah", "Doha",
    "Kuwait City", "Muscat", "Sao Paulo", "Rio de Janeiro", "Santiago", "Bogota", "Mexico City",
    "New York", "Los Angeles", "Miami", "Toronto", "Johannesburg", "Cape Town", "Durban", "Nairobi",
    "Lagos", "Mumbai", "Delhi", "Bengaluru", "Tiruppur", "Chennai", "Kolkata", "Ahmedabad", "Surat",
    "Paris", "Berlin", "Madrid", "Barcelona", "Milan", "Rome", "Amsterdam", "Brussels", "Stockholm",
    "Copenhagen", "Warsaw", "Lisbon", "Athens", "Dublin", "Sydney", "Melbourne", "Tokyo", "Seoul",
    "Singapore", "Kuala Lumpur", "Jakarta", "Ho Chi Minh City", "Bangkok", "Cairo", "Casablanca",
  ],
};

// Original editorial articles (in-house written) on India's apparel manufacturing growth.
export const blog = {
  eyebrow: "INSIGHTS",
  title: "India's Apparel Manufacturing on the Rise",
  subtitle:
    "Perspectives from K.S.E. Inc. on the growth, exports and future of Indian garment production.",
  articles: [
    {
      id: "india-textile-market-outlook",
      category: "Market Outlook",
      date: "July 2, 2025",
      readTime: "5 min read",
      title: "Why India's Textile & Apparel Market Is Entering a Golden Decade",
      image: "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4",
      excerpt:
        "With a large domestic market, deep raw-material access and a young workforce, India's textile and apparel sector is positioned for sustained double-digit momentum.",
      body: [
        "India has long been one of the world's largest producers of cotton and one of the biggest textile and apparel economies. What is changing today is the pace: a combination of a fast-growing domestic consumer base, government incentives for manufacturing, and global brands actively diversifying their sourcing is pushing the industry into a new growth phase.",
        "For production houses like K.S.E. Inc., this shift is visible on the factory floor. Order books are broadening across categories \u2014 knits, wovens, casual and loungewear \u2014 and buyers increasingly value partners who can offer design, sampling and compliant, on-time production under one roof.",
        "The next decade is likely to reward manufacturers who invest in capacity, sustainability and reliability. India's structural advantages in fibre, labour and a maturing ecosystem make it one of the most compelling apparel sourcing destinations in the world.",
      ],
    },
    {
      id: "china-plus-one-sourcing",
      category: "Global Sourcing",
      date: "June 24, 2025",
      readTime: "4 min read",
      title: "\u2018China + 1\u2019 Sourcing Is Putting India Firmly on the Map",
      image: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1200",
      excerpt:
        "Global brands are rebalancing supply chains \u2014 and India is emerging as a preferred second engine for apparel production.",
      body: [
        "As international retailers look to reduce concentration risk, the \u2018China + 1\u2019 strategy has moved from boardroom slides to real purchase orders. India, with its scale, English-speaking merchandising talent and vertically integrated clusters, is a natural beneficiary.",
        "Buyers from the UK, Europe, the Middle East and Africa are increasingly placing programmes with Indian manufacturers that can hold quality across seasons. This is exactly the kind of long-term partnership K.S.E. Inc. has built over three decades.",
        "The winners in this rebalancing will be factories that combine competitive costing with dependable lead times and strong compliance \u2014 turning a sourcing experiment into a lasting relationship.",
      ],
    },
    {
      id: "knitwear-tiruppur-story",
      category: "Clusters",
      date: "June 10, 2025",
      readTime: "6 min read",
      title: "Inside Tiruppur: How India's Knitwear Capital Powers Global Wardrobes",
      image: "https://images.pexels.com/photos/31199588/pexels-photo-31199588.jpeg",
      excerpt:
        "From single jersey tees to engineered jacquards, Tiruppur's ecosystem is a masterclass in specialised, high-volume knit production.",
      body: [
        "Tiruppur has grown into one of the most important knitwear clusters in the world. Its strength lies in density \u2014 spinning, knitting, dyeing, printing, cutting and stitching all sit within a tight radius, enabling remarkable speed and flexibility.",
        "For a manufacturer, this ecosystem means faster development cycles and the ability to scale a proven style quickly. K.S.E. Inc.'s knits capability draws on this depth to deliver large, consistent programmes month after month.",
        "As sustainability expectations rise, Tiruppur is also investing in water recycling and cleaner processing \u2014 reinforcing its role as a responsible, future-ready hub for global buyers.",
      ],
    },
    {
      id: "apparel-exports-growth",
      category: "Exports",
      date: "May 28, 2025",
      readTime: "4 min read",
      title: "Indian Apparel Exports: Building Toward the Next Big Milestone",
      image: "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=1200",
      excerpt:
        "New trade agreements and rising buyer confidence are setting the stage for a significant expansion in India's garment exports.",
      body: [
        "India's apparel exports reach markets across Europe, the Middle East, Africa and the Americas. Recent and upcoming free-trade agreements are expected to improve access and tariff positions in key destinations, giving exporters fresh tailwinds.",
        "Beyond policy, buyer confidence matters. Brands want proof of ethical manufacturing, certified processes and the ability to repeat quality at scale \u2014 all areas where established Indian production houses are strengthening their credentials.",
        "K.S.E. Inc. already serves brands across six regions and four continents, and sees rising interest from buyers looking to consolidate more of their sourcing in India.",
      ],
    },
    {
      id: "sustainability-in-manufacturing",
      category: "Sustainability",
      date: "May 15, 2025",
      readTime: "5 min read",
      title: "Sustainable by Design: The New Baseline for Garment Factories",
      image: "https://images.unsplash.com/photo-1640746942093-cec8e647596d",
      excerpt:
        "Recycled fabrics, cleaner processing and certified environmental systems are no longer optional \u2014 they are expected.",
      body: [
        "Sustainability has moved from a marketing message to a manufacturing requirement. Buyers increasingly ask for recycled and responsibly sourced fabrics, reduced water and chemical use, and audited environmental management systems.",
        "K.S.E. Inc.'s ISO 14001:2015 certification reflects a structured approach to managing environmental impact \u2014 from resource use to waste \u2014 across its operations.",
        "The factories that treat sustainability as a design principle, rather than a compliance checkbox, will earn the trust of the world's most demanding brands.",
      ],
    },
    {
      id: "technology-on-the-floor",
      category: "Technology",
      date: "April 30, 2025",
      readTime: "4 min read",
      title: "Smarter Factories: How Technology Is Reshaping Garment Production",
      image: "https://images.unsplash.com/photo-1736281957869-7f80909c3b2e",
      excerpt:
        "Computerised machines, digital printing and better planning tools are lifting both quality and speed on the shop floor.",
      body: [
        "Modern garment production is increasingly data-driven. Computerised buttoning and bartacking, automated cutting and digital printing reduce variability and speed up development.",
        "Just as important are planning and tracking systems that keep orders on schedule \u2014 a decisive advantage when buyers value reliability as much as cost.",
        "Investing in the right machinery mix, as K.S.E. Inc. does across its knits and shirts units, allows a factory to promise \u2014 and deliver \u2014 consistent output at scale.",
      ],
    },
    {
      id: "man-made-fibre-opportunity",
      category: "Fabrics",
      date: "April 18, 2025",
      readTime: "5 min read",
      title: "Beyond Cotton: India's Man-Made Fibre Opportunity",
      image: "https://images.unsplash.com/photo-1705250466297-51e6d0a1e6e6",
      excerpt:
        "Polyester, viscose and blended fabrics are opening new categories and price points for Indian manufacturers.",
      body: [
        "India is historically strong in cotton, but the fastest-growing global demand is often in man-made and blended fibres \u2014 polyester tees, viscose casuals and performance fabrics.",
        "Manufacturers who expand into CVC, polyester and viscose blends can serve a wider range of programmes, from everyday basics to fashion-forward prints.",
        "K.S.E. Inc.'s range already spans cotton, cotton-lycra, CVC and 100% polyester constructions \u2014 giving buyers flexibility across seasons and segments.",
      ],
    },
    {
      id: "skilling-the-workforce",
      category: "People",
      date: "April 4, 2025",
      readTime: "4 min read",
      title: "The Human Advantage: Skilling India's Garment Workforce",
      image: "https://images.pexels.com/photos/4492077/pexels-photo-4492077.jpeg",
      excerpt:
        "A large, young and increasingly skilled workforce remains India's most durable competitive edge.",
      body: [
        "Garment manufacturing is still, at its heart, a people business. Skilled operators, quality checkers and merchandisers make the difference between a good factory and a great one.",
        "India's demographic advantage \u2014 a young and growing workforce \u2014 is being paired with structured training and better working conditions across responsible factories.",
        "At K.S.E. Inc., a team of skilled employees underpins every order, ensuring craftsmanship is maintained even as volumes grow.",
      ],
    },
    {
      id: "fast-fashion-to-responsible",
      category: "Trends",
      date: "March 22, 2025",
      readTime: "5 min read",
      title: "From Fast Fashion to Responsible Volume: What Buyers Want Now",
      image: "https://images.unsplash.com/photo-1618354691551-44de113f0164",
      excerpt:
        "Speed still matters \u2014 but buyers increasingly reward manufacturers who pair agility with accountability.",
      body: [
        "The industry conversation has shifted. Buyers still want speed and freshness, but they also want traceability, fair labour practices and lower environmental impact.",
        "This favours manufacturers who can move quickly without cutting corners \u2014 delivering responsible volume rather than throwaway fashion.",
        "Production houses with in-house design, sampling and compliance are best placed to meet this dual demand for agility and accountability.",
      ],
    },
    {
      id: "why-partner-indian-manufacturer",
      category: "Sourcing Guide",
      date: "March 8, 2025",
      readTime: "6 min read",
      title: "A Buyer's Guide: What to Look for in an Indian Manufacturing Partner",
      image: "https://images.unsplash.com/photo-1596552571892-2dda2c594670",
      excerpt:
        "Capacity, compliance, communication and consistency \u2014 the four Cs that separate reliable partners from the rest.",
      body: [
        "Choosing a manufacturing partner is a long-term decision. The best partners offer transparent capacity, verifiable certifications, responsive merchandising and \u2014 above all \u2014 consistency across repeat orders.",
        "Ask about machinery mix, monthly capacity, quality systems and how the factory handles development and sampling. These answers reveal whether a partner can truly scale with your brand.",
        "With 30+ years of experience, three facilities and a global client base, K.S.E. Inc. was built to meet exactly these expectations \u2014 turning first orders into lasting partnerships.",
      ],
    },
  ],
};

export const contact = {
  eyebrow: "GET IN TOUCH",
  title: "Let's Build Something Together",
  address:
    "19, Niraj Industrial Estate, Off Mahakali Caves Road, Behind Paper Box Factory, Andheri (East), Mumbai \u2013 400093, Maharashtra, India",
  phone: "+91 22 2687 1148",
  people: [
    {
      role: "Managing Director",
      name: "Mr. Tinku Sethi",
      phones: ["+91 98200 10399", "+91 93722 40719"],
      whatsapp: "919820010399",
      email: "tinku@ksekirpal.in",
      linkedin: "https://www.linkedin.com/in/tinku-sethi",
    },
    {
      role: "Marketing Executive",
      name: "Mr. Guransh Singh Sethi",
      phones: ["+91 75069 40399", "+91 75069 40300"],
      whatsapp: "917506940399",
      email: "guranshsethi123@gmail.com",
      linkedin: "https://www.linkedin.com/in/guransh-singh-sethi",
    },
  ],
};

export const footer = {
  address:
    "19, Niraj Industrial Estate, Off Mahakali Caves Road, Andheri (East), Mumbai \u2013 400093, Maharashtra, India.",
  columns: [
    {
      title: "Our Company",
      links: ["About Us", "Our People", "Capabilities", "Facilities", "Showroom"],
    },
    {
      title: "Products",
      links: ["Knit T-Shirts", "Shirts", "Casual Wear", "Sleepwear", "Kids Wear"],
    },
  ],
};
